<template>
    <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_3700_12050)">
            <path
                d="M17.2971 23.0153C23.6199 23.0153 28.7456 17.8632 28.7456 11.5077C28.7456 5.15216 23.6199 0 17.2971 0C10.9743 0 5.84863 5.15216 5.84863 11.5077C5.84863 17.8632 10.9743 23.0153 17.2971 23.0153Z"
                fill="#E7EEF1"
            />
            <path
                d="M3.35985 3.50232L0.373291 6.50432V29.0193H19.2882V3.50232H3.35985Z"
                fill="white"
            />
            <path
                d="M4.35537 7.50499H0.373291V6.50432L3.35985 3.50232H4.35537V7.50499Z"
                fill="#6BFFFF"
            />
            <path
                d="M19.2882 14.5097V3.50232H3.35985L0.373291 6.50432V29.0193H19.2882V27.018"
                stroke="#011837"
                stroke-miterlimit="10"
                stroke-linecap="round"
            />
            <path
                d="M1.3689 7.50499H4.35546V4.50299"
                stroke="#011837"
                stroke-miterlimit="10"
            />
            <path
                d="M22.2748 15.01L16.7994 17.5117V24.016L22.2748 26.5177L27.7502 24.016V17.5117L22.2748 15.01Z"
                fill="#6BFFFF"
                stroke="#011837"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16.7994 17.5117L22.2748 20.0133L27.7502 17.5117"
                stroke="#011837"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M22.2748 20.0134V26.5177"
                stroke="#011837"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M21.777 29.6548L30.2389 25.7922V15.7355L21.777 11.8729"
                stroke="#A2A9B1"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M3.85767 11.0073L4.85319 12.008L6.84423 9.50635"
                stroke="#011837"
                stroke-linejoin="round"
            />
            <path
                d="M3.85767 15.01L4.85319 16.0107L6.84423 13.509"
                stroke="#011837"
                stroke-linejoin="round"
            />
            <path
                d="M3.85767 19.0127L4.85319 20.0133L6.84423 17.5117"
                stroke="#011837"
                stroke-linejoin="round"
            />
            <path
                d="M3.85767 23.0153L4.85319 24.016L6.84423 21.5143"
                stroke="#011837"
                stroke-linejoin="round"
            />
            <path
                d="M8.83521 11.0073H15.3061"
                stroke="#A2A9B1"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M8.83521 15.01H15.3061"
                stroke="#A2A9B1"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M8.83521 19.0127H15.3061"
                stroke="#A2A9B1"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M8.83521 23.0153H15.3061"
                stroke="#A2A9B1"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
        </g>
        <defs>
            <clipPath id="clip0_3700_12050">
                <rect width="30.6122" height="30" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>